export enum CampaignType {
  Charge = 'C',
  Both = 'A',
  Partner = 'P',
}
